import Vue from 'vue'
import Router from 'vue-router'
import routes from './view'
import service from './service'

Vue.use(Router)

let router = new Router({
  routes
})

let isFirst = true
let isPush = false
let originPush = router.push
let originReplace = router.replace
router.push = function (...args) {
  isPush = true
  originPush.apply(router, args)
}

router.replace = function (...args) {
  isPush = true
  originReplace.apply(router, args)
}
router.beforeEach(function (to, from, next) {
  if (!from.meta) {
    from.meta = {}
  }
  from.meta.scrollTop = document.body.scrollTop
  next()
})

router.afterEach(function (route) {
  service.common.title = ''
  service.common.tool = false
  service.wechat.callShare()
  if (!route.meta) {
    route.meta = {}
  }
  if (isFirst) {
    isFirst = false
    isPush = true
  }
  route.meta.isPush = isPush
  isPush = false
})

export default router



// WEBPACK FOOTER //
// ./src/router.js